import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconDocuments from '@/assets/icons/heroIcons/Documents.svg';
import IconIdentification from '@/assets/icons/heroIcons/Identification.svg';
import IconClipboardList from '@/assets/icons/heroIcons/ClipboardList.svg';
import IconFolderOpen from '@/assets/icons/heroIcons/FolderOpen.svg';
import IconDocumentText from '@/assets/icons/heroIcons/DocumentText.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import IconSpeakerphone from '@/assets/icons/heroIcons/Speakerphone.svg';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { EXTERNAL_LINKS, LINKS } from '@/constants/links';
import React from 'react';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import { ProductBox } from '@/components/boxes';
import HeroSimple from '@/sections/HeroSimple';
import { SeoHeader } from '@/components/SeoHeader';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(84);
  const {
    menuPromoBanners
  } = t0;
  usePageView("documents");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["documents", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("banner.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <HeroSimple title={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconDocuments />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("items.1.title");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("items.1.text");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      to: LINKS().conditions,
      testId: "documentsConditions",
      analyticsParam: "documentsConditions"
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t8 || $[19] !== t9) {
    t11 = <ProductBox icon={t7} title={t8} description={t9} link={t10} />;
    $[18] = t8;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <IconIdentification />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t("items.2.title");
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t) {
    t14 = t("items.2.text");
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      to: LINKS().informationMemorandum,
      testId: "documentsInformationMemorandum",
      analyticsParam: "documentsInformationMemorandum"
    };
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t14) {
    t16 = <ProductBox icon={t12} title={t13} description={t14} link={t15} />;
    $[27] = t13;
    $[28] = t14;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IconClipboardList />;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t) {
    t18 = t("items.3.title");
    $[31] = t;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t) {
    t19 = t("items.3.text");
    $[33] = t;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      to: LINKS().pricing,
      testId: "documentsPricing",
      analyticsParam: "documentsPricing"
    };
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t18 || $[37] !== t19) {
    t21 = <ProductBox icon={t17} title={t18} description={t19} link={t20} />;
    $[36] = t18;
    $[37] = t19;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <IconFolderOpen />;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t) {
    t23 = t("items.4.title");
    $[40] = t;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t) {
    t24 = t("items.4.text");
    $[42] = t;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      to: LINKS().personalInformation,
      testId: "documentsPersonalInformation",
      analyticsParam: "documentsPersonalInformation"
    };
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t23 || $[46] !== t24) {
    t26 = <ProductBox icon={t22} title={t23} description={t24} link={t25} />;
    $[45] = t23;
    $[46] = t24;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] !== isCsLanguage || $[49] !== t) {
    t27 = isCsLanguage && <ProductBox icon={<IconSpeakerphone />} title={t("items.5.title")} description={t("items.5.text")} link={{
      to: EXTERNAL_LINKS().marketingPromos,
      testId: "documentsMarketing",
      analyticsParam: "documentsMarketing"
    }} />;
    $[48] = isCsLanguage;
    $[49] = t;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <IconDocumentText />;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== isCsLanguage || $[53] !== t) {
    t29 = isCsLanguage ? t("items.6.title") : t("items.5.title");
    $[52] = isCsLanguage;
    $[53] = t;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] !== isCsLanguage || $[56] !== t) {
    t30 = isCsLanguage ? t("items.6.text") : t("items.5.text");
    $[55] = isCsLanguage;
    $[56] = t;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      to: LINKS().otherDocuments,
      testId: "documentsOtherDocuments",
      analyticsParam: "documentsOtherDocuments"
    };
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== t29 || $[60] !== t30) {
    t32 = <ProductBox icon={t28} title={t29} description={t30} link={t31} />;
    $[59] = t29;
    $[60] = t30;
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== t11 || $[63] !== t16 || $[64] !== t21 || $[65] !== t26 || $[66] !== t27 || $[67] !== t32) {
    t33 = <div className="relative z-10 pb-20 text-left lg:pb-40"><div className="px-4"><div className="mx-auto flex max-w-292 flex-row flex-wrap justify-center gap-4 *:w-[23.5rem] *:max-w-full lg:*:min-h-[17.125rem]">{t11}{t16}{t21}{t26}{t27}{t32}</div></div></div>;
    $[62] = t11;
    $[63] = t16;
    $[64] = t21;
    $[65] = t26;
    $[66] = t27;
    $[67] = t32;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t33 || $[70] !== t6) {
    t34 = <div className="bg-blue-50">{t6}{t33}</div>;
    $[69] = t33;
    $[70] = t6;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[72] = t35;
  } else {
    t35 = $[72];
  }
  let t36;
  if ($[73] !== isCsLanguage || $[74] !== t) {
    t36 = <div className="relative z-10"><MoreInfoSection buttons={isCsLanguage ? [{
        analyticsParam: "documentsMorDeferredPayment",
        icon: <IconDeferredPayment className="fillButtonIcon" />,
        testId: "documentsMoreInfoDeferredPayment",
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment
      }, {
        analyticsParam: "documentsMoreInfoRevolvingApplication",
        icon: <IconMaxi className="fillButtonIcon" />,
        testId: "documentsMoreInfoRevolvingApplication",
        title: t("core:products.revolving"),
        to: LINKS().revolving
      }, {
        analyticsParam: "documentsMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "documentsMoreInfoPayInThree",
        title: t("core:link.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "documentsMoreInfoCard",
        icon: <IconCard className="fillButtonIcon" />,
        testId: "documentsMoreInfoCard",
        title: t("core:products.card"),
        to: LINKS().card
      }] : [{
        analyticsParam: "documentsMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "documentsMoreInfoPayInThree",
        title: t("core:products.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "documentsMoreInfoWhereToShop",
        icon: <IconShoppingCart className="fillButtonIcon" />,
        testId: "documentsMoreInfoWhereToShop",
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop
      }, {
        analyticsParam: "documentsMobileApp",
        icon: <IconMobile className="fillButtonIcon" />,
        testId: "documentsMoreInfoMobileApp",
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp
      }, {
        analyticsParam: "documentsMoreInfoAboutCompany",
        icon: <IconUser className="fillButtonIcon" />,
        testId: "documentsMoreInfoAboutCompany",
        title: t("core:link.aboutUs"),
        to: LINKS().aboutCompany
      }]} /></div>;
    $[73] = isCsLanguage;
    $[74] = t;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[76] = t37;
  } else {
    t37 = $[76];
  }
  let t38;
  if ($[77] !== t36) {
    t38 = <div className="relative overflow-hidden bg-blue-100">{t36}{t37}</div>;
    $[77] = t36;
    $[78] = t38;
  } else {
    t38 = $[78];
  }
  let t39;
  if ($[79] !== menuPromoBanners || $[80] !== t34 || $[81] !== t38 || $[82] !== t4) {
    t39 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t34}{t35}{t38}</Layout>;
    $[79] = menuPromoBanners;
    $[80] = t34;
    $[81] = t38;
    $[82] = t4;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  return t39;
}
export const getStaticProps: GetStaticProps = async ctx => ({
  props: {
    menuPromoBanners: await getAllPageMenuPromoBanners(),
    ...(await getIntlProps(ctx, ['core', 'documents']))
  }
});